import type { SideBarOptionTypes } from '../types'

import cx from 'classnames'
import { Link } from 'react-router-dom'

import styles from '../sidebar.module.css'
import { SidebarOptionKind } from '../types'

interface SidebarProps {
  onDuty: boolean
  selected: SidebarOptionKind | 'closed' | null
  onClick: (name: SidebarOptionKind) => void
  items: SideBarOptionTypes[]
}

export function Sidebar ({ onDuty, selected, onClick, items }: SidebarProps): JSX.Element {
  return (
    <div
      className={cx(styles.sidebar, {
        [styles.on as string]: onDuty,
        [styles.off as string]: !onDuty
      })}
    >
      {items.map(({ name, id, icon, style, isLink, isButton, fn, link, tooltip }) => {
        if (isButton && fn) {
          return (
            <button
              title={tooltip}
              key={id}
              id={id}
              style={style}
              className={cx(styles.item, {
                [styles.active as string]: selected === name && selected !== 'User'
              }, typeof id === 'string' && `sidebar-button-${id}`)}
              onClick={fn}
              data-sentry-unblock='true'
              data-test-id={typeof id === 'string' && `sidebar-button-${id}`}
            >
              {icon ?? (
                <p
                  className={styles.sidebarOption}
                  title={tooltip}
                >
                  {name.substring(0, 1)}
                </p>
              )}
            </button>
          )
        }

        return name !== SidebarOptionKind.separator
          ? isLink
            ? (
              <Link
                title={tooltip}
                to={link ?? '/'}
                className={cx(styles.item, typeof id === 'string' && `sidebar-link-${id}`, {
                  [styles.active as string]: selected === name
                })}
                data-sentry-unblock='true'
                data-test-id={typeof id === 'string' && `sidebar-link-${id}`}
              >
                {icon ?? <p className={styles.sidebarOption}>{name.substring(0, 1)}</p>}
              </Link>
            )
            : (
              <button
                title={tooltip}
                key={name}
                className={cx(styles.item, typeof id === 'string' && `sidebar-button-${id}`, {
                  [styles.active as string]: selected === name && selected !== 'User'
                })}
                onClick={() => onClick(name)}
                data-sentry-unblock='true'
                data-test-id={typeof id === 'string' && `sidebar-button-${id}`}
              >
                {icon ?? (
                  <p
                    className={styles.sidebarOption}
                    title={tooltip}
                  >
                    {name.substring(0, 1)}
                  </p>
                )}
              </button>
            )
          : <div style={{ width: '100%' }}>{icon}</div>
      })}
    </div>
  )
}
